import { Injectable } from '@angular/core';
import { tokenNotExpired } from 'angular2-jwt';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {

  public token: string;

  constructor(
    private http: Http,
    private router: Router) {
    // set token if saved in local storage
    this.token = localStorage.getItem('token_id');
  }

  isAuthenticated() {
    return tokenNotExpired('token_id');
  }

  addAuthToken(): RequestOptions {
    // add authorization header with jwt token
    const headers = new Headers({ 'Authorization': 'Bearer ' + this.token });
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  login(username: string, password: string): Observable<boolean> {
    return this.http.post(environment.alApiUrl + '/Auth/Token',
      { email: username, password: password })
      .map((response: Response) => {
        // login successful if there's a jwt token in the response
        const token = response.json() && response.json().token;
        if (token) {
          // set token property
          this.token = token;

          // store username and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify({ email: username, token: token }));
          localStorage.setItem('token_id', token );

          // return true to indicate successful login
          return true;
        } else {
          // return false to indicate failed login
          return false;
        }
      }).catch((error: any) => {
        console.error('An friendly error occurred', error);
        return Observable.throw(error.message || error);
      });
  }

  get redirectUrl(): string {
    return localStorage.getItem('redirectUrl');
  }


  public logout(): void {
    // clear token remove user from local storage to log user out
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token_id');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts